import { render, staticRenderFns } from "./switch.component.vue?vue&type=template&id=87dbb910&scoped=true&lang=pug"
import script from "./switch.component.vue?vue&type=script&lang=ts"
export * from "./switch.component.vue?vue&type=script&lang=ts"
import style0 from "./switch.component.vue?vue&type=style&index=0&id=87dbb910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dbb910",
  null
  
)

export default component.exports